// modules
import React from 'react'
import { connect } from 'react-redux'

import { bindActionCreators } from 'redux'

import { Spin } from '@emmacare/common/design-system/components/Spin'

// actions, selectors
import {
  fetchRequiredAppData,
  isRequiredUserDataLoaded$,
  logout
} from 'src/store/modules/user'

// HOC
import withAsyncLoader from 'src/HOC/withAsyncLoader'

// component
import SimpleLayout from './SimpleLayout'

const mapStateToProps = (state) => ({
  isRequiredUserDataLoaded: isRequiredUserDataLoaded$(state)
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchRequiredAppData,
      logout
    },
    dispatch
  )

const load = ({ isRequiredUserDataLoaded, fetchRequiredAppData, logout }) =>
  isRequiredUserDataLoaded
    ? Promise.resolve()
    : fetchRequiredAppData().catch(logout)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withAsyncLoader({
    load,
    loader: (
      <div
        style={{ height: '100vh', display: 'flex', justifyContent: 'center' }}
      >
        <Spin size="large" />
      </div>
    )
  })(SimpleLayout)
)
